import { useQuery } from '@tanstack/react-query';
import { fetchRegions, type Region } from '@/api/regions';

export function useRegions() {
  return useQuery<Region[]>({
    queryKey: ['regions'],
    queryFn: ({ signal }) => fetchRegions(signal),
    // マスタは backend のデプロイ時にしか変わらない
    staleTime: Infinity,
    // 既定の 3 回リトライだと、失敗時にエラー表示が出るまで約 7 秒かかるため 1 回に抑える
    retry: 1,
  });
}
